import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas da equipe, sob `RequerPermissao` como **rota-mãe**: a verificação acontece uma vez, no pai, em
 * vez de ser repetida (e esquecida) em cada página filha.
 *
 * 🚨 Esta é a segunda tranca. A que vale é o `@Permissao('usuarios.ver')` do backend — aqui só evitamos
 * mostrar uma tela que o servidor negaria.
 *
 * As páginas carregam sob demanda (1.12): o `RequerPermissao` decide **antes** de o código da página ser
 * baixado, então quem não pode abrir a equipe nem chega a buscar o pedaço dela.
 */
export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="usuarios.ver" />,
    children: [
      {
        path: '/usuarios',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaUsuarios'),
          (m) => m.PaginaUsuarios,
          'Abrindo a equipe…',
        ),
      },
      {
        path: '/usuarios/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaUsuarioDetalhe'),
          (m) => m.PaginaUsuarioDetalhe,
          'Abrindo a pessoa…',
        ),
      },
    ],
  },
  {
    // Papéis (1.10): `papeis.ver` abre as telas; sem `papeis.gerir` a matriz é só leitura. A tranca que
    // vale é o `@Permissao()` de cada rota do backend.
    element: <RequerPermissao permissao="papeis.ver" />,
    children: [
      {
        path: '/papeis',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaPapeis'),
          (m) => m.PaginaPapeis,
          'Abrindo os papéis…',
        ),
      },
      {
        path: '/papeis/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaPapelPermissoes'),
          (m) => m.PaginaPapelPermissoes,
          'Abrindo as permissões…',
        ),
      },
    ],
  },
];
